import { IataAirline } from "../../iata/objects/iataAirline";

export interface FlightSpecificLevel {
    id?: number,
    flight_specifics: 0 | 1 | 2 | 3 | 4 | 5 | 6,
    flight_class_booking: string,
    flight_fare_basis: string,
    flight_iata_airline: null | IataAirline,
    extra_type?: 'BAGGAGE' | 'SEAT',
    is_infant?: boolean,
}


export const EMPTY_FLIGHT_SPECIFIC_LEVEL: FlightSpecificLevel = {
    flight_specifics: 0,
    flight_class_booking: '',
    flight_fare_basis: '',
    flight_iata_airline: null
};
